import React from 'react';
import ReactDOM from 'react-dom';

import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import './index.scss';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import App from './components/App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (!registration) return;

    const applyUpdate = () => {
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
    };

    // Prevent multiple reloads
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });

    // If waiting service worker already exists, skip waiting immediately
    if (registration.waiting) {
      applyUpdate();
    } else {
      // Otherwise, listen for new installing worker
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        newWorker?.addEventListener('statechange', () => {
          if (
            newWorker.state === 'installed' &&
            navigator.serviceWorker.controller
          ) {
            applyUpdate();
          }
        });
      });
    }
  },
});
